module.exports = [{"id":1,"lang":"畅通"},{"id":2,"lang":"火爆"},{"id":3,"lang":"爆满"},{"id":6,"lang":"预备"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/server_load_option.json
// module id = F0jK
// module chunks = 1